import styled from 'styled-components'

const LanguageListStyled = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
`

export { LanguageListStyled }
